<template>
    <div class="stepper">
        <div class="stepper__item"
             :class="{
                    'active': currentStep === 1,
                    'finished': currentStep > 1
                }"
        >
            <p class="stepper__item-text">1.{{ $t('style_quiz.steps.profile') }}</p>
            <div class="stepper__item-dot">
                <div class="stepper__item-dot-inner"></div>
            </div>
        </div>
        <div class="stepper__item"
             :class="{
                    'active': currentStep === 2,
                    'finished': currentStep > 2
                }"
        >
            <p class="stepper__item-text">2.{{ $t('style_quiz.steps.rooms') }}</p>
            <div class="stepper__item-dot">
                <div class="stepper__item-dot-inner"></div>
            </div>
        </div>
        <div class="stepper__item"
             :class="{
                    'active': currentStep === 3,
                    'finished': currentStep > 3
                }"
        >
            <p class="stepper__item-text">3.{{ $t('style_quiz.steps.furnitures') }}</p>
            <div class="stepper__item-dot">
                <div class="stepper__item-dot-inner"></div>
            </div>
        </div>
        <div class="stepper__item"
             :class="{
                    'active': currentStep === 4,
                    'finished': currentStep > 4
                }"
        >
            <p class="stepper__item-text">4.{{ $t('style_quiz.steps.deadline') }}</p>
            <div class="stepper__item-dot">
                <div class="stepper__item-dot-inner"></div>
            </div>
        </div>
        <div class="stepper__item"
             :class="{
                    'active': currentStep === 5,
                    'finished': currentStep > 5
                }"
        >
            <p class="stepper__item-text">5.{{ $t('style_quiz.steps.budget') }}</p>
            <div class="stepper__item-dot">
                <div class="stepper__item-dot-inner"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CreateProjectStepsMenu",
    props: {
        currentStep: {
            default: 1,
            type: Number
        }
    }
}
</script>

<style scoped lang="scss">
@use '@/css/quiz';

.stepper {
    &__item {
        &.active {
            .stepper__item-text {
                color: #529096;
            }
            .stepper__item-dot-inner {
                border-color: #529096;
            }
        }

        &-text {
            @media screen and (max-width: 372px) {
                font-size: 1.1rem;
            }
        }
    }
}
</style>
